module.exports = __webpack_public_path__ + "static/media/HeartWriter-video.50fb8ace.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/HeartWriter-video.webm
// module id = 115
// module chunks = 0